<template>
    <ContentPage title="Commissies - Koper">
        <div>
            <p>
                Tenzij schriftelijk anders overeengekomen of anders aangegeven in de bijzondere veilingvoorwaarden, zijn de commissies die de koper
                aan Fleequid verschuldigd is voor de aan- en verkoop van elk afzonderlijk voertuig via de Marketplace of de aan- en verkoopdiensten en
                -systemen van Fleequid als volgt:
            </p>
        </div>

        <div class="mx-auto flex flex-col items-center gap-2">
            <div>
                <SaleFeesInfoTable />
            </div>
        </div>

        <div>
            <p><strong>*</strong> exclusief btw</p>
            <p><strong>**</strong> plus btw indien van toepassing</p>
        </div>

        <div>
            <p class="mb-1 font-bold">Voorbeeld 1:</p>
            <p>Toewijzingsprijs: €&nbsp;6.000 +&nbsp;btw</p>
            <p>
                Commissie verschuldigd aan Fleequid door de Koper: <br class="md:hidden" />
                <span class="font-medium">
                    vast bedrag van €&nbsp;250 +&nbsp;(€&nbsp;6.000 * 8,75%) =
                    <span class="whitespace-nowrap">€&nbsp;775 +&nbsp;btw</span>
                </span>
            </p>
        </div>

        <div>
            <p class="mb-1 font-bold">Voorbeeld 2:</p>
            <p>Toewijzingsprijs: €&nbsp;180.000 +&nbsp;btw</p>
            <p>
                Commissie verschuldigd aan Fleequid door de Koper: <br class="md:hidden" />
                <span class="font-medium">
                    €&nbsp;250 +&nbsp;(€&nbsp;100.000 * 8,75%) +&nbsp;(€&nbsp;80.000 * 3,75%) =
                    <span class="whitespace-nowrap">€&nbsp;12.000 +&nbsp;btw</span>
                </span>
            </p>
        </div>
    </ContentPage>
</template>
